import React from 'react';

export const QuotaModal = ({ show, onClose, navigate, t }) => {
  if (!show) return null;
  return (
    <div data-testid="quota-modal-overlay" onClick={onClose} style={{
      position: 'fixed', inset: 0, zIndex: 999,
      backgroundColor: 'rgba(0,0,0,0.88)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      animation: 'fadeIn 0.4s ease-out',
    }}>
      <div onClick={e => e.stopPropagation()} data-testid="quota-modal" style={{
        backgroundColor: '#0a0a0a', border: '1px solid rgba(212,175,55,0.3)',
        borderRadius: 16, padding: '48px 40px', maxWidth: 460, width: '90%',
        textAlign: 'center', boxShadow: '0 0 80px rgba(212,175,55,0.08)',
        animation: 'fadeInUp 0.5s ease-out',
      }}>
        <div style={{
          width: 72, height: 72, borderRadius: '50%', margin: '0 auto 24px',
          backgroundColor: 'rgba(212,175,55,0.08)', border: '2px solid #D4AF37',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 0 40px rgba(212,175,55,0.2)',
        }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10" strokeWidth="2"/>
          </svg>
        </div>
        <h3 data-testid="quota-modal-title" style={{ fontFamily: "'Georgia', serif", fontSize: 22, color: '#D4AF37', marginBottom: 16, lineHeight: 1.4, fontWeight: 400 }}>
          Votre premier Sanctuaire est complet.
        </h3>
        <p data-testid="quota-modal-body" style={{ fontFamily: "'Georgia', serif", fontSize: 14, color: '#FAF3E0', lineHeight: 1.8, marginBottom: 32 }}>{t('quota_message')}</p>
        <button onClick={() => { onClose(); navigate('/offres'); }} data-testid="quota-modal-cta" style={{
          fontFamily: "'Georgia', serif", fontSize: 15, fontWeight: 600, letterSpacing: 0.5,
          background: 'linear-gradient(145deg, #D4AF37, #B8860B)', color: '#000', border: 'none', padding: '14px 36px', borderRadius: 8,
          cursor: 'pointer', transition: 'all 0.3s', width: '100%', boxShadow: '0 4px 24px rgba(212,175,55,0.3)',
        }}
          onMouseEnter={e => { e.target.style.transform = 'translateY(-2px)'; }}
          onMouseLeave={e => { e.target.style.transform = 'translateY(0)'; }}
        >{t('svc_upgrade')}</button>
        <button onClick={onClose} data-testid="quota-modal-close" style={{ background: 'none', border: 'none', cursor: 'pointer', marginTop: 12, padding: 8 }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
      <style>{`@keyframes fadeInUp { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </div>
  );
};

export const RestoreSuccessModal = ({ restoreSuccess, onClose, photos, openViewer, setActiveTab, goldBtn }) => {
  if (!restoreSuccess) return null;
  return (
    <div data-testid="restore-success-modal" onClick={onClose} style={{
      position: 'fixed', inset: 0, zIndex: 999,
      backgroundColor: 'rgba(0,0,0,0.85)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      animation: 'fadeIn 0.3s ease-out',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        backgroundColor: '#0a0a0a', border: '1px solid rgba(212,175,55,0.3)',
        borderRadius: 16, padding: '40px 36px', maxWidth: 440, width: '90%', textAlign: 'center',
      }}>
        <div style={{
          width: 64, height: 64, borderRadius: '50%', margin: '0 auto 20px',
          backgroundColor: 'rgba(212,175,55,0.08)', border: '2px solid #D4AF37',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 0 30px rgba(212,175,55,0.2)',
        }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        </div>
        <p data-testid="restore-success-text" style={{ fontFamily: "'Georgia', serif", fontSize: 20, color: '#D4AF37', marginBottom: 12, lineHeight: 1.5 }}>
          Votre Tresor a retrouve son eclat
        </p>
        <p style={{ fontFamily: "'Georgia', serif", fontSize: 14, color: '#FAF3E0', fontStyle: 'italic', marginBottom: 28, lineHeight: 1.6 }}>
          Le temps n'a plus de prise...
        </p>
        <button data-testid="restore-success-view" onClick={() => {
          onClose();
          const idx = photos.findIndex(p => p.id === restoreSuccess.photoId);
          if (idx >= 0) { setActiveTab('tresors'); setTimeout(() => openViewer(idx), 200); }
        }} style={{ ...goldBtn(true), width: '100%', marginBottom: 12, boxShadow: '0 4px 24px rgba(212,175,55,0.3)' }}>
          Voir le resultat
        </button>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', width: '100%', marginTop: 8, padding: 8, display: 'flex', justifyContent: 'center' }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
      <style>{`@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }`}</style>
    </div>
  );
};
